// extracted by css-extract-rspack-plugin
export default {"menuList":"styles_menuList__8FC0h","menuItem":"styles_menuItem__dLbOZ"};